import buildApprovalStatusFilters from './approvalStatusFilters'
import buildChannelAccountFilters from './channelAccountFilters'
import { buildLabelFilters } from './labelFilter'
import { buildStoryFilters } from './storyFilter'

// Pass in jsonAPIEntities from Redux store
// desiredFilters is an array of objects that
// represent options for a single section of
// the <FilterBar> component
// desiredFilter: {
//   groupOrAble,
//   inclusivity,
//   name,
//   placeholderType,
// }

const buildFilterTree = (jsonApiEntities = {}, desiredFilters = []) => {
  const filterTree = desiredFilters.map(
    ({ groupOrAble, inclusivity, name, placeholderType }) => {
      switch (name) {
        case 'Channels & Accounts':
          return buildChannelAccountFilters({
            accounts: jsonApiEntities.accounts,
            services: jsonApiEntities.services,
          })
        case 'Approval Status':
          return buildApprovalStatusFilters(placeholderType)
        case 'Labels':
          return buildLabelFilters({
            labelSets: jsonApiEntities.labelSets,
            groupOrAble,
            inclusivity,
          })
        case 'Stories':
          return buildStoryFilters({
            stories: jsonApiEntities.stories,
            groupOrAble,
            inclusivity,
          })
        default:
          return null
      }
    }
  )

  const cleanedTree = filterTree.filter((filter) => Boolean(filter))

  return cleanedTree
}

export default buildFilterTree

export { buildLabelFilters, buildStoryFilters }
